// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1IkGt","colBig":"styles_colBig__1784V","colSmall":"styles_colSmall__2A77P"};